
import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    "@media (max-width:479.95px)": {
      flexDirection: "column",
    },
  },
});

export default useStyles;
